import { baseUrl } from '../constants/config'
import axios from 'axios'

const instance = axios.create({
  baseURL: baseUrl
})
export default instance
